// libs
import ReactDOM from "react-dom";
import React, { Suspense } from "react";
import { CookiesProvider } from "react-cookie";
import { Provider } from "react-redux";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { KeycloakConfig, Interceptor, messageConfig } from "@dx-hrsol/util-kit";
import { message } from "antd";
// actions
import errorsHandlerAction from "./actions/errorsHandlerAction";
// contexts
import { ErrorsHandlerProvider } from "./contexts/ErrorHandleContext";
// components
import LoadingPage from "./components/LoadingPage";
// routers
import { AppRouter } from "./routes/appRouter";
// store
import store from "./store";
// others
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import { AXIOS_INSTANCE } from "./config";
// styles
import "antd/dist/antd.css";
import "./index.css";

const ORG_CODE = process.env.REACT_APP_ORG_CODE;

if (ORG_CODE) {
  // util-kit derives both values from the first hostname label by default.
  Object.assign(KeycloakConfig, { realm: ORG_CODE });
  AXIOS_INSTANCE.defaults.headers.common["Accept-Org"] = ORG_CODE;
}

Interceptor(AXIOS_INSTANCE, store, errorsHandlerAction);

const initOptions = {
  onLoad: "login-required",
  checkLoginIframe: false,
};

messageConfig({ message });

ReactDOM.render(
  <ReactKeycloakProvider authClient={KeycloakConfig} initOptions={initOptions}>
    <Provider store={store}>
      <ErrorsHandlerProvider>
        <CookiesProvider>
          <Suspense fallback={<LoadingPage />}>
            <AppRouter />
          </Suspense>
        </CookiesProvider>
      </ErrorsHandlerProvider>
    </Provider>
  </ReactKeycloakProvider>,
  document.getElementById("root")
);

serviceWorker.register();
